
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/layout/Header/Currency/index.less?modules";
export default {"currency_container": `currency_container-5odQr_QK`,"percentage": `percentage-Fvg23B1T`,"label": `label-iEJYKqiJ`,"item": `item-c3FqjNsT`,"flag": `flag-qrfoYfV_`}
